import React from 'react';
import { connect } from 'react-redux';
import { dataType } from '@/constants/data-type';
import DataTable from '@/components/DataTable/DataTable';
import TabHeader from '@/components/TabHeader/TabHeader';
import '@/assets/styles/components/ipo/listed-focus.scss';
import { IPOActions } from '@/actions/trading';
import { PARAMS } from '@/constants/params';
import { SERVICES_RESP } from '@/configurations';
import { Converter } from '../../../helpers/functions';
import { CUSTOM_STYLES } from '@/constants/app';
import { utilsFunction } from '@/helpers/functions';

class ListedFocus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      columnDefs: [
        // {
        //   headerName: props.language.common_reference_no,
        //   colId: 'common_reference_no',
        //   field: 'subscriptionID',
        //   headerClass: 'table-header',
        //   cellClass: 'table-cell cell-action',
        //   dataType: dataType.TEXT,
        //   sort: 'desc'
        // },
        {
          headerName: props.language.common_symbol,
          colId: 'common_symbol',
          field: 'customSymbol',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT
        },
        {
          headerName: props.language.common_name,
          colId: 'common_name',
          field: 'instrumentShortname',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.STOCK_NAME,
          minWidth: 300,
          tooltipField: utilsFunction.switchToolTipsLanguage(this.props.language, 'instrumentShortname', 'instrumentCShortName'),
          cellRendererParams: {
            stockName: 'instrumentShortname',
            chineseStockName: 'instrumentChineseShortName'
          }
        },
        {
          headerName: props.language.ipo_issue_day,
          colId: 'ipo_issue_day',
          field: 'eipostartDate',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.SHORT_DATE
        },
        {
          headerName: props.language.ipo_closing_date,
          colId: 'ipo_closing_date',
          field: 'eipoendDate',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.SHORT_DATE
        },
        {
          headerName: props.language.ipo_listing_date,
          colId: 'ipo_listing_date',
          field: 'listingDate',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.SHORT_DATE
        },
        {
          headerName: props.language.common_currency,
          colId: 'common_currency',
          field: 'currencyID',
          headerClass: 'table-header',
          cellClass: 'table-cell',
          dataType: dataType.TEXT
        },
        {
          headerName: props.language.common_offer_price_two,
          colId: 'common_offer_price_two',
          field: 'customOfferPrice',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-right',
          dataType: dataType.TEXT
        },
        {
          headerName: props.language.ipo_confirmed_price_two,
          colId: 'ipo_confirmed_price_two',
          field: 'confirmedPrice',
          headerClass: 'table-header text-end',
          cellClass: 'table-cell text-right',
          dataType: dataType.PRICE
        },
        // {
        //   headerName: props.language.common_allotment_date,
        //   colId: 'common_allotment_date',
        //   field: 'allotmentDate',
        //   headerClass: 'table-header text-end',
        //   cellClass: 'table-cell text-right',
        //   dataType: dataType.TEXT
        // },
        // {
        //   headerName: props.language.applied_qty,
        //   colId: 'applied_qty',
        //   field: 'appliedQty',
        //   headerClass: 'table-header text-end',
        //   cellClass: 'table-cell',
        //   dataType: dataType.NUMBER
        // },
        // {
        //   headerName: props.language.alloted_qty,
        //   colId: 'alloted_qty',
        //   field: 'allottedQty',
        //   headerClass: 'table-header text-end',
        //   cellClass: 'table-cell',
        //   dataType: dataType.NUMBER
        // },
        // {
        //   headerName: props.language.common_total_amount_of_payment,
        //   colId: 'common_total_amount_of_payment',
        //   field: 'totalAmount',
        //   headerClass: 'table-header text-end',
        //   cellClass: 'table-cell text-right',
        //   dataType: dataType.TEXT
        // },
        // {
        //   headerName: props.language.refund_amount,
        //   colId: 'refund_amount',
        //   field: 'totalAmount',
        //   headerClass: 'table-header text-end',
        //   cellClass: 'table-cell text-right',
        //   dataType: dataType.TEXT
        // }
      ],
      data: null,
      listedHeader: [{ id: 1, title: 'ipo_allotted_focus' }]
    }
  }

  render() {
    const { columnDefs, data, listedHeader } = this.state;

    return (
      <React.Fragment>
        <div className="listed-focus-container">
          <TabHeader
            customStyle={CUSTOM_STYLES.HEADER_NORMAL}
            tabs={listedHeader}
            refresh
            onRefresh={this.handleRefresh}
          />
          <DataTable
            columnDefs={columnDefs}
            innerRef={e => this.ListedFocusRef = e}
            data={data} />
        </div>
      </React.Fragment>
    )
  }

  handleRefresh = () => {
    this.getListedFocus();
  }

  getListedFocus = () => {
    const { currentTradingAccount, language } = this.props;
    const { clientID, tradingAccSeq } = currentTradingAccount
    const params = {
      [PARAMS.CLIENT_ID]: clientID,
      [PARAMS.TRADING_ACCOUNT_ID]: clientID,
      [PARAMS.TRADING_ACC_SEQ]: tradingAccSeq,
      [PARAMS.LANGUAGE]: language.lang
    }
    if (this.ListedFocusRef) {
      this.ListedFocusRef.toggleLoadingOverlay(true);
    }
    this.props.getApplication(params, res => {
      if (res.result.errorCode === SERVICES_RESP.SUCCESS_CODE) {
        this.setState({
          data: Converter.mapIPOListedFocusData(res.result.itemList)
        })
      } else {
        this.setState({ data: [] })
      }
      this.ListedFocusRef.toggleLoadingOverlay(false);
    })
  }

  componentDidUpdate(prevProps) {
    const { currentTradingAccount } = this.props
    if (currentTradingAccount && prevProps.currentTradingAccount !== currentTradingAccount) {
      this.getListedFocus();
    }
    if (this.props.clientID !== prevProps.clientID) {
      this.getListedFocus();
    }
    if (this.props.language !== prevProps.language) {
      this.getListedFocus();
    }
  }

  componentDidMount() {
    const { currentTradingAccount } = this.props;
    if (currentTradingAccount) {
      this.getListedFocus();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return
    }
  }
}

export default connect(
  state => ({
    language: state.app.language,
    markets: state.trade.markets,
    user: state.auth.user,
    currentTradingAccount: state.trade.currentTradingAccount,
    clientID: state.trade.clientID
  }),
  dispatch => ({
    getApplication: (p, res) => dispatch(IPOActions.getApplicationAction(p, res)),
  })
)(ListedFocus)
